// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.styles_tableBody__oB6pc .styles_tripleDots__azu50 {
  font-size: 24px;
  font-weight: 900;
  cursor: pointer; }

.styles_fullWidthTable__YP-Ub {
  width: 100%;
  border-collapse: collapse; }

/* Table.css */
/* Заголовок таблицы */
.styles_tableHeader__dEfAX th {
  top: 0;
  background-color: inherit;
  text-align: left;
  color: #9e9e9e;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  /* 171.429% */
  letter-spacing: 0.1px; }

.styles_tableBody__oB6pc td {
  text-align: left;
  vertical-align: top;
  color: #212121;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  /* 171.429% */
  letter-spacing: 0.1px;
  padding: 10px 0 10px 0; }

/* Первый столбец */
.styles_tableColumn1__kz5bB {
  width: 15%; }

/* Второй столбец */
.styles_tableColumn2__wKVBc {
  width: 30%; }

/* Третий столбец */
.styles_tableColumn3__BK86g {
  width: 10%; }

/* Четвертый столбец */
.styles_tableColumn7__bcX7d {
  width: 10%; }

/* Пятый и последующие столбцы */
.styles_tableColumn5__VqpFP,
.styles_tableColumn6__jAEeb,
.styles_tableColumn4__hU6dh {
  width: 12%; }

.styles_fullImage__-vy7\\+ {
  width: 100vw;
  height: 100vh;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  background-color: #00000070;
  backdrop-filter: blur(5px);
  z-index: 9000;
  cursor: pointer; }
  .styles_fullImage__container__uzeTL {
    position: relative;
    width: 560px;
    height: 600px;
    overflow: hidden;
    background-color: white;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0px 0px 8px 0px rgba(68, 87, 104, 0.25);
    padding: 20px; }
  .styles_fullImage__header__1K8ug {
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    display: flex;
    justify-content: space-between; }
  .styles_fullImage__content__XZSNy {
    height: 520px;
    overflow: auto; }
    .styles_fullImage__content__XZSNy div {
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      padding: 15px 0 15px 0; }
`, "",{"version":3,"sources":["webpack://./src/pages/info/task/processes/styles.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe,EAAA;;AAEjB;EACE,WAAW;EACX,yBAAyB,EAAA;;AAE3B,cAAA;AAEA,sBAAA;AACA;EACE,MAAM;EACN,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EAAE,aAAA;EACnB,qBAAqB,EAAA;;AAGvB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EAAE,aAAA;EACnB,qBAAqB;EACrB,sBAAsB,EAAA;;AAExB,mBAAA;AACA;EACE,UAAU,EAAA;;AAGZ,mBAAA;AACA;EACE,UAAU,EAAA;;AAGZ,mBAAA;AACA;EACE,UAAU,EAAA;;AAGZ,sBAAA;AACA;EACE,UAAU,EAAA;;AAGZ,gCAAA;AACA;;;EAGE,UAAU,EAAA;;AAGZ;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,MAAM;EACN,OAAO;EACP,2BAA2B;EAC3B,0BAA0B;EAC1B,aAAa;EACb,eAAe,EAAA;EACf;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,mDAAmD;IACnD,aAAa,EAAA;EAEf;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,8BAA8B,EAAA;EAEhC;IACE,aAAa;IACb,cAAc,EAAA;IAFf;MAKG,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,sBAAsB,EAAA","sourcesContent":[".tableBody .tripleDots {\n  font-size: 24px;\n  font-weight: 900;\n  cursor: pointer;\n}\n.fullWidthTable {\n  width: 100%;\n  border-collapse: collapse;\n}\n/* Table.css */\n\n/* Заголовок таблицы */\n.tableHeader th {\n  top: 0;\n  background-color: inherit;\n  text-align: left;\n  color: #9e9e9e;\n  font-feature-settings: 'clig' off, 'liga' off;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px; /* 171.429% */\n  letter-spacing: 0.1px;\n}\n\n.tableBody td {\n  text-align: left;\n  vertical-align: top;\n  color: #212121;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px; /* 171.429% */\n  letter-spacing: 0.1px;\n  padding: 10px 0 10px 0;\n}\n/* Первый столбец */\n.tableColumn1 {\n  width: 15%;\n}\n\n/* Второй столбец */\n.tableColumn2 {\n  width: 30%;\n}\n\n/* Третий столбец */\n.tableColumn3 {\n  width: 10%;\n}\n\n/* Четвертый столбец */\n.tableColumn7 {\n  width: 10%;\n}\n\n/* Пятый и последующие столбцы */\n.tableColumn5,\n.tableColumn6,\n.tableColumn4 {\n  width: 12%;\n}\n\n.fullImage {\n  width: 100vw;\n  height: 100vh;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 0;\n  left: 0;\n  background-color: #00000070;\n  backdrop-filter: blur(5px);\n  z-index: 9000;\n  cursor: pointer;\n  &__container {\n    position: relative;\n    width: 560px;\n    height: 600px;\n    overflow: hidden;\n    background-color: white;\n    border-radius: 4px;\n    background: #fff;\n    box-shadow: 0px 0px 8px 0px rgba(68, 87, 104, 0.25);\n    padding: 20px;\n  }\n  &__header {\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 600;\n    display: flex;\n    justify-content: space-between;\n  }\n  &__content {\n    height: 520px;\n    overflow: auto;\n\n    div{\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      padding: 15px 0 15px 0;\n    }\n\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableBody": `styles_tableBody__oB6pc`,
	"tripleDots": `styles_tripleDots__azu50`,
	"fullWidthTable": `styles_fullWidthTable__YP-Ub`,
	"tableHeader": `styles_tableHeader__dEfAX`,
	"tableColumn1": `styles_tableColumn1__kz5bB`,
	"tableColumn2": `styles_tableColumn2__wKVBc`,
	"tableColumn3": `styles_tableColumn3__BK86g`,
	"tableColumn7": `styles_tableColumn7__bcX7d`,
	"tableColumn5": `styles_tableColumn5__VqpFP`,
	"tableColumn6": `styles_tableColumn6__jAEeb`,
	"tableColumn4": `styles_tableColumn4__hU6dh`,
	"fullImage": `styles_fullImage__-vy7+`,
	"fullImage__container": `styles_fullImage__container__uzeTL`,
	"fullImage__header": `styles_fullImage__header__1K8ug`,
	"fullImage__content": `styles_fullImage__content__XZSNy`
};
export default ___CSS_LOADER_EXPORT___;
